import {IController} from "../../../controllers/IController";
import {InjectionToken} from "@angular/core";
import {ModelKey} from "../../../models/ModelKey";
import {FileObjectsModel} from "../_models/FileObjectsModel";
import {FileUploadConfigModel} from "../_models/FileUploadConfigModel";
import {FileUploadStatesModel} from "../_models/FileUploadStatesModel";

export const IT_FILE_UPLOAD_CONTROLLER = new InjectionToken<IFileUploadController>('IT_FILE_UPLOAD_CONTROLLER');

export const MK_FILE_OBJECTS = new ModelKey<FileObjectsModel>('MK_FILE_OBJECTS');
export const MK_FILE_UPLOAD_CONFIG = new ModelKey<FileUploadConfigModel>('MK_FILE_UPLOAD_CONFIG');
export const MK_FILE_UPLOAD_STATES = new ModelKey<FileUploadStatesModel>('MK_FILE_UPLOAD_STATES');

export interface IFileUploadController extends IController {

  handleConfigOverwrite(eventData: any): void;
  handleLoadFiles(eventData: any): void;
  handleFileInput(eventData: any): void;
  handleRemoveFile(eventData: any): void;
}
